import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBookmarkAddComponent } from "./med-icon-bookmark-add.component";

@NgModule({
  declarations: [
    MedIconBookmarkAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBookmarkAddComponent,
  ],
})
export class MedIconBookmarkAddModule { }
